"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertSummaryComponent = void 0;
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var Alert_1 = require("../icons/Alert");
var Check_1 = require("../icons/Check");
var styles = require("../styles/DataAlerts");
var AlertSummaryComponent = function (props) {
    var renderHeader = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.alertSummaryHeader }, Localize_1.Messages.RecommendationHeader()),
            React.createElement("div", { className: styles.alertSummaryDescription }, Localize_1.Messages.RecommendationDescription())));
    };
    var renderQualityCheck = function () {
        return (React.createElement("div", { className: styles.alertSummaryDetail + " " + styles.alertSummaryDetailBorder },
            React.createElement("div", { className: styles.alertQualityCheckIcon }, props.qualityCheckPass ? React.createElement(Check_1.Check, null) : React.createElement(Alert_1.Alert, null)),
            React.createElement("div", { className: styles.alertSummaryDetailText },
                Localize_1.Messages.QualityCheck(),
                " \u2014 ",
                props.qualityCheckPass ? Localize_1.Messages.QualityCheckPass() : Localize_1.Messages.QualityCheckFail())));
    };
    var renderReviewAlert = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.alertSummaryDetail + " " + styles.alertSummaryDetailBorder },
                React.createElement("div", { className: styles.recommendedAlertNumber }, props.recommendationsNeedReview),
                React.createElement("div", { className: styles.alertSummaryDetailText }, Localize_1.Messages.ReviewAlerts())),
            React.createElement("div", { className: styles.alertSummaryDetail + " " + styles.alertSummaryDetailBorder },
                React.createElement("div", { className: styles.ignoredAlertNumber }, props.ignoredRecommendations),
                React.createElement("div", { className: styles.alertSummaryDetailText }, Localize_1.Messages.IgnoredAlerts())),
            React.createElement("div", { className: styles.alertSummaryDetail },
                React.createElement("div", { className: styles.acceptedAlertNumber }, props.acceptedRecommendations),
                React.createElement("div", { className: styles.alertSummaryDetailText }, Localize_1.Messages.AcceptedAlerts()))));
    };
    return (React.createElement("div", { className: styles.alertSummaryContainer + " " + (props.hideBorder ? '' : styles.alertBorder) },
        renderHeader(),
        renderQualityCheck(),
        renderReviewAlert()));
};
exports.AlertSummaryComponent = AlertSummaryComponent;
//# sourceMappingURL=AlertSummaryComponent.js.map